import {useEffect, useState} from "react";
import {generateArray} from "../../../utils/array-helper";
import {LightBulbBox} from "./boxes/lights-on-wheel/light-bulb/light-bulb.box";
import {LightEmittedBox} from "./boxes/lights-on-wheel/light-bulb/light-emitted.box";
import {LightIntrisecBox} from "./boxes/lights-on-wheel/light-bulb/light-intrisec.box";
import {LightStrongBox} from "./boxes/lights-on-wheel/light-bulb/light-strong.box";
import {LightSocketBox} from "./boxes/lights-on-wheel/light-socket/light-socket.box";
import {LightsOnWheelBox} from "./boxes/lights-on-wheel/lights-on-wheel.box";
import {getScaledSize} from "./wheel-sizing-helper";

const NUMBER_OF_WHEEL_LIGHTS = 36;

const classesForAnimationSteps = [
    'lights-on-wheel',
    'lights-on-wheel pink-2n',
    'lights-on-wheel pink-2n1 yellow-2n',
    'lights-on-wheel peach-2n',
    'lights-on-wheel yellow-2n1 pink-2n',
    'lights-on-wheel peach-2n1',
    'lights-on-wheel pink-2n1 yellow-2n',
    'lights-on-wheel peach-2n',
    'lights-on-wheel pink-2n yellow-2n1',
    'lights-on-wheel peach-2n1',
    'lights-on-wheel pink-2n1 yellow-2n',
    'lights-on-wheel',
    'lights-on-wheel pink-2n yellow-2n1',
    'lights-on-wheel peach-2n',
    'lights-on-wheel pink-2n yellow-2n1',
    'lights-on-wheel',
];
  

type ILightsOnWheelProps = {
    startAnimation: boolean;
    wheelSize: number;
};
export const LightsOnWheel: React.FC<ILightsOnWheelProps> = (props) => {
    const { startAnimation, wheelSize } = props;
    const [lightStepNumber, setLightStepNumber] = useState(0);

    const [boxShadowBlurSizes, setBoxShadowBlurSizes] = useState<[number, number]>([14.2, 8.52]);

    useEffect(() => {
        setBoxShadowBlurSizes([
            getScaledSize(wheelSize, 5),
            getScaledSize(wheelSize, 3)
        ]);
    }, [wheelSize]);

    useEffect(() => {
        if (startAnimation) {
            requestAnimationFrame(() => {
                setLightStepNumber(1);
            });
        } else {
            requestAnimationFrame(() => {
                setLightStepNumber(0);
            });
        }
    }, [startAnimation]);

    return <LightsOnWheelBox
        className={classesForAnimationSteps[lightStepNumber]}
        onTransitionEnd={(e) => {
            // this callback is called multiple times
            // (once for each transition event that bubbles here from child nodes. Each bulb has 3 elements that animates
            // So this callback is called 3 times for each bulb that animates, and there are between 18 to 36 bulbs that animates each step)
            // So, I cannot use the syntax: setLightStepNumber(current => current + 1); because this will super rapidly change the state to a very high number
            // Instead I use: setLightStepNumber(lightStepNumber + 1); witch rely on value stalling, that sucks, that is a hack but what the hell, I have no other idea
            // Sue me or fire me
            requestAnimationFrame(() => {
                setLightStepNumber(lightStepNumber + 1);
            });
        }}
    >
        {generateArray(NUMBER_OF_WHEEL_LIGHTS).map((idx) => (
            <LightSocketBox key={idx} socketIndex={idx} totalSockets={NUMBER_OF_WHEEL_LIGHTS} className="bulb-socket" >
                <LightBulbBox socketIndex={idx} totalSockets={NUMBER_OF_WHEEL_LIGHTS} className="bulb-slot" >
                    <LightEmittedBox className="bulb-light " boxShadowBlurSize={boxShadowBlurSizes[0]} />
                    <LightIntrisecBox className="bulb " >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 124 124" fill="none" style={{display: "block"}}>
                            <circle cx="62" cy="62" r="14" fill="white"></circle>
                            <circle cx="70" cy="87" r="14" fill="white"></circle>
                            <circle cx="49" cy="42" r="9" fill="white"></circle>
                        </svg>
                    </LightIntrisecBox>
                    <LightStrongBox className="bulb-strong-light" boxShadowBlurSize={boxShadowBlurSizes[1]} />
                </LightBulbBox>
            </LightSocketBox>
        ))}
  </LightsOnWheelBox>
}
